import axios from 'axios'
import config from '@/config'

const SESSION_TOKEN_KEY = 'whitehorse_session_token'

function resolveApiBaseUrl() {
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL
  }

  return config.apiMode === 'local' ? 'http://localhost:3000' : ''
}

export const API_BASE_URL = resolveApiBaseUrl()

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true'
  },
  timeout: 30000
})

export function getToken() {
  return localStorage.getItem(SESSION_TOKEN_KEY) || ''
}

export function setSessionToken(token) {
  const normalized = String(token || '').trim()
  if (normalized) {
    localStorage.setItem(SESSION_TOKEN_KEY, normalized)
    apiClient.defaults.headers.common.Authorization = `Bearer ${normalized}`
    return
  }

  localStorage.removeItem(SESSION_TOKEN_KEY)
  delete apiClient.defaults.headers.common.Authorization
}

export function clearSessionToken() {
  setSessionToken('')
}

setSessionToken(getToken())

apiClient.interceptors.request.use(
  requestConfig => {
    requestConfig.headers['ngrok-skip-browser-warning'] = 'true'
    const sessionToken = getToken()
    if (sessionToken && !requestConfig.headers.Authorization) {
      requestConfig.headers.Authorization = `Bearer ${sessionToken}`
    }
    return requestConfig
  },
  error => Promise.reject(error)
)

apiClient.interceptors.response.use(
  response => {
    if (response.data && response.data.success !== undefined) {
      if (response.data.success && response.data.data !== undefined) {
        response.data = response.data.data
      } else if (!response.data.success) {
        const errorMessage = response.data.message || 'Operation failed'
        return Promise.reject(new Error(errorMessage))
      }
    }
    return response
  },
  error => {
    if (error.response) {
      const status = error.response.status
      switch (status) {
        case 401:
          clearSessionToken()
          if (!['/login', '/auth/callback'].includes(window.location.pathname)) {
            window.location.href = '/login'
          }
          break
        default:
          break
      }
    }
    return Promise.reject(error)
  }
)
